import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { CardNumberElement, CardExpiryElement, CardCVCElement, injectStripe, } from 'react-stripe-elements';
import Grid from '@material-ui/core/Grid/Grid';
import { useAlert, types } from 'react-alert';
import { useHistory } from 'react-router-dom';
import { PrimaryButton } from '../../components';
import { useClinic } from '../../../model/hooks/clinic/ClinicHooks';
import { Constants } from '../../../common/constants';
const stripeInputStyle = {
    base: {
        fontSize: '16px',
    },
};
const StripeForm = (props) => {
    const { stripe } = props;
    const { t } = useTranslation();
    const reactAlert = useAlert();
    const history = useHistory();
    const { registerCreditAccount, loading } = useClinic();
    const { billingPlanPaymentMethodType } = Constants;
    const onClickChange = async () => {
        var _a, _b, _c, _d;
        // strinpeからtoken取得
        const res = await ((_a = stripe) === null || _a === void 0 ? void 0 : _a.createToken());
        if ((_b = res) === null || _b === void 0 ? void 0 : _b.error) {
            reactAlert.show(res.error.message, { type: types.ERROR });
            return;
        }
        // imory_serverからクレジットカード登録処理を実行
        try {
            await registerCreditAccount(billingPlanPaymentMethodType.creditCard, (_d = (_c = res) === null || _c === void 0 ? void 0 : _c.token) === null || _d === void 0 ? void 0 : _d.id);
            reactAlert.show(t('登録しました'), { type: types.SUCCESS });
            history.push('/home/account');
        }
        catch (e) {
            console.log(e);
            reactAlert.show(t('エラーが発生しました'), { type: types.ERROR });
        }
    };
    return (React.createElement(SContainer, null,
        React.createElement(Grid, { container: true, spacing: 3, justify: "center" },
            React.createElement(Grid, { item: true, xs: 10 },
                React.createElement(CardNumberElement, { style: stripeInputStyle })),
            React.createElement(Grid, { item: true, xs: 5 },
                React.createElement(CardExpiryElement, { style: stripeInputStyle })),
            React.createElement(Grid, { item: true, xs: 5 },
                React.createElement(CardCVCElement, { style: stripeInputStyle })),
            React.createElement(Grid, { item: true, xs: 6, style: { marginTop: '16px' } },
                React.createElement(PrimaryButton, { type: "submit", loading: loading, fullWidth: true, onClick: onClickChange }, t('変更する'))))));
};
const SContainer = styled.div `
  .StripeElement {
    border-bottom: 1px solid #aaa;
    padding-bottom: 4px;
  }
`;
export default injectStripe(StripeForm);
